// material
import { Stack, Box } from "@mui/material";

// ----------------------------------------------------------------------

export default function HeadText(props) {
  return (
    <Stack
      direction="row"
      sx={{
        marginTop: { xs: "68px", md: "90px", lg: "96px" },
        borderBottom: "1px solid #ffffff80",
        borderTop: "1px solid #ffffff80",
      }}
    >
      <Stack
        justifyContent="center"
        alignItems="center"
        sx={{ borderRight: "1px solid #ffffff80", width: "12%" }}
      >
        <Box
          component="img"
          alt="loading"
          src="/assets/map.png"
          sx={{ width: "70%", height: "auto" }}
        />
      </Stack>
      <Stack justifyContent="center" sx={{ pl: "1%", width: "88%" }}>
        <p className="head_text">{props.title}</p>
      </Stack>
    </Stack>
  );
}
